import MusicNoteIcon from "@mui/icons-material/MusicNote";
import HomeIcon from "@mui/icons-material/Home";
import CodeIcon from "@mui/icons-material/Code";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SchoolIcon from "@mui/icons-material/School";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import TheaterConedyIcon from "@mui/icons-material/TheaterComedy";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
export const categoryes = [
  { name: "New", Icon: <HomeIcon /> },
  { name: "Movies", Icon: <HomeIcon /> },
  { name: "Video Song", Icon: <HomeIcon /> },
  { name: "Js Mastery", Icon: <CodeIcon /> },
  { name: "Coding", Icon: <CodeIcon /> },
  { name: "ReactJs", Icon: <CodeIcon /> },
  { name: "NextJs", Icon: <OndemandVideoIcon /> },
  { name: "Video", Icon: <OndemandVideoIcon /> },
  { name: "Music", Icon: <MusicNoteIcon /> },
  { name: "Education", Icon: <SchoolIcon /> },
  { name: "Potcast", Icon: <GraphicEqIcon /> },
  { name: "Movie", Icon: <OndemandVideoIcon /> },
  { name: "Gaming", Icon: <SportsEsportsIcon /> },
  { name: "Live", Icon: <LiveTvIcon /> },
  { name: "Sport", Icon: <FitnessCenterIcon /> },
  { name: "fashion", Icon: <CheckroomIcon /> },
  { name: "Beauty", Icon: <FaceRetouchingNaturalIcon /> },
  { name: "Comedy", Icon: <TheaterConedyIcon /> },
  { name: "Gym", Icon: <FitnessCenterIcon /> },
  { name: "Crypto", Icon: <DeveloperModeIcon /> },
];
export const demoProfilePicture="https://download.logo.wine/logo/YouTube/YouTube-Logo.wine.png"
export const logo = "https://download.logo.wine/logo/YouTube/YouTube-Logo.wine.png";
export const demothumbnailUrl = "../data/thumb.png";
export const demochannelUrl = "https://www.youtube.com/watch?v=yJxs1ckrecY";
export const demoVideoUrl = "../data/video.mp4";
export const demoChannelTitle = "Javascript Master";
export const demoVideoTitle =
  "Building and Deploy and Javascript & React Api Project Course";
